import { motion } from 'framer-motion';
import styled, { keyframes } from 'styled-components';

export const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100dvh;
  height: 100%;
  width: 100%;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  padding: 4rem;
  width: 100%;
  gap: 2rem;
  padding-left: 27.5rem;
  animation: ${fadeIn} 0.3s ease-in;
  /* overflow: hidden; */
  height: 100%;
  min-height: calc(100dvh - 122px);
  @media (max-width: 875px) {
    padding-left: 4rem;
    padding-top: 10rem;
  }
`;

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 2rem;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 6rem;
  @media (max-width: 875px) {
    justify-content: center;
    flex-direction: column;
  }
`;

export const Title = styled.span`
  font-family: 'FrankfurterEF-Medium';
  font-size: 4rem;
  letter-spacing: -0.178px;
  @media (max-width: 875px) {
    text-align: center;
  }
`;
export const Subtitle = styled.span`
  font-family: 'Avenir-Medium';
  font-size: 2.5rem;
  letter-spacing: -0.178px;
  @media (max-width: 875px) {
    text-align: center;
  }
`;

export const WaContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  transition: all 0.3s ease-in-out;

  &:active {
    opacity: 0.45;
  }
`;
export const WaText = styled.span`
  user-select: none;
  font-family: 'Avenir-Medium';
  font-size: 1.8rem;
  letter-spacing: 0.067px;
`;

export const ExportWrapper = styled.div`
  position: relative;
`;

export const ExportButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: #484888;
  color: white;
  border: none;
  border-radius: 1rem;
  padding: 1rem 1.5rem;
  cursor: pointer;
  font-family: 'Avenir-Heavy';

  transition: 0.2s ease;
  font-size: 2rem;

  &:active {
    background: #32325f;
  }
`;

export const Dropdown = styled(motion.div)`
  position: absolute;
  top: 110%;
  right: 0;
  background: #fff;
  border: 1px solid #484888;
  border-radius: 0.5rem;
  overflow: hidden;

  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.3);
  z-index: 10;
`;

export const DropdownItem = styled.button`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.7rem 1.2rem;
  width: 100%;
  background: none;
  border: none;

  cursor: pointer;
  font-size: 1.6rem;

  &:hover {
    background: #48488820;
  }
`;
